module.exports = __webpack_public_path__ + "static/media/marketplace-dropbox-icon.91ed55b3.svg";